import React from 'react';
import { styles } from './ProductCardSkeleton.css';
import { Box } from '../Box/Box';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { ProductCardVariant } from '../../../ProductCard/ProductCard';

export type ProductCardSkeletonProps = { variant?: ProductCardVariant | 'mini'; shouldShimmer?: boolean };

export const ProductCardSkeleton = ({ shouldShimmer = false, variant = 'default' }: ProductCardSkeletonProps) => {
  return (
    <div data-testid="product-card-skeleton" className={styles.container({ variant })}>
      {!['small', 'mini'].includes(variant) ? (
        <div className={styles.topSection({ variant })}>
          <Box
            width="50%"
            height="30px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
          <Box
            width="20px"
            height="20px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
        </div>
      ) : null}
      <div className={styles.imageContainer({ variant })}>
        <div className={styles.image({ variant })}>
          <Box height="100%" backgroundColor={palette.secondary.main} border="none" shouldShimmer={shouldShimmer} />
        </div>
      </div>

      <div className={styles.title}>
        <Box
          width="100%"
          height="20px"
          backgroundColor={palette.secondary.main}
          border="none"
          shouldShimmer={shouldShimmer}
        />
        <Box
          width="50%"
          height="16px"
          backgroundColor={palette.secondary.main}
          border="none"
          shouldShimmer={shouldShimmer}
        />
      </div>

      {variant === 'landscape' ? (
        <div className={styles.content}>
          <Box
            width="70%"
            height="16px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
          <Box
            width="85%"
            height="16px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
          <Box
            width="55%"
            height="16px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
          <Box
            width="95%"
            height="16px"
            backgroundColor={palette.secondary.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
        </div>
      ) : null}

      <div className={styles.bottomSection({ variant })}>
        <Box
          width="90%"
          height="50px"
          backgroundColor={palette.secondary.main}
          border="none"
          shouldShimmer={shouldShimmer}
        />
        {variant !== 'small' ? (
          <Box
            width="100%"
            height="50px"
            backgroundColor={palette.border.main}
            border="none"
            shouldShimmer={shouldShimmer}
          />
        ) : null}
      </div>
    </div>
  );
};
